import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Breadcrumbs from "@/components/Breadcrumbs";
import { LegalContent } from "@shared/legal";

export default function Privacy() {
  const privacy = LegalContent.privacy;
  const terms = LegalContent.termsOfService;

  return (
    <div className="min-h-screen">
      <Navigation />

      <div className="w-full bg-brand-martinique">
        <section id="privacy" className="w-full bg-brand-martinique border-black/10">
          <div className="max-w-[1440px] mx-auto px-8 pt-4">
            <Breadcrumbs
              items={[{ label: "Privacy & Legal" }]}
              variant="dark"
            />
          </div>

          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 md:px-8 py-6 sm:py-8 lg:py-8 lg:pb-[120px]">
            {/* Privacy Policy */}
            <div className="mb-8 sm:mb-12">
              <h2 className="font-agency text-2xl sm:text-3xl md:text-h2 font-bold text-white mb-4 sm:mb-6 md:mb-8 break-words">
                {privacy.title}
              </h2>

              <div className="space-y-4 sm:space-y-6 font-martianmono text-sm sm:text-base md:text-text-lg-custom text-brand-gray">
                {privacy.sections.map((section, idx) => (
                  <div key={idx}>
                    <h3 className="font-agency text-lg sm:text-xl md:text-h5 text-white mb-3 sm:mb-4 break-words">
                      {section.heading}
                    </h3>
                    <div className="space-y-3 sm:space-y-4">
                      {section.content.map((text, i) => (
                        <p key={i} className="break-words leading-relaxed">{text}</p>
                      ))}
                      {section.listItems && (
                        <ul className="list-disc pl-4 sm:pl-6 space-y-2 mt-3 sm:mt-4">
                          {section.listItems.map((item, i) => (
                            <li key={i} className="break-words leading-relaxed">
                              {item.label ? (
                                <>
                                  <strong className="font-bold">{item.label}:</strong> {item.text}
                                </>
                              ) : (
                                item.text
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                      {section.additionalContent && (
                        <p className="mt-3 sm:mt-4 break-words leading-relaxed">{section.additionalContent}</p>
                      )}
                    </div>
                  </div>
                ))}

                <div className="pt-3 sm:pt-4 border-t border-white/10">
                  <p className="text-xs sm:text-sm md:text-text-sm-custom text-brand-gray/80 break-words">
                    <strong className="font-bold">Last Updated:</strong> {privacy.lastUpdated}
                  </p>
                </div>
              </div>
            </div>

            {/* Terms of Service */}
            <div className="mb-8 sm:mb-12 pt-8 sm:pt-12 border-t border-white/10">
              <h2 className="font-agency text-2xl sm:text-3xl md:text-h2 font-bold text-white mb-4 sm:mb-6 md:mb-8 break-words">
                {terms.title}
              </h2>

              <div className="space-y-4 sm:space-y-6 font-martianmono text-sm sm:text-base md:text-text-lg-custom text-brand-gray">
                {terms.sections.map((section, idx) => (
                  <div key={idx}>
                    <h3 className="font-agency text-lg sm:text-xl md:text-h5 text-white mb-3 sm:mb-4 break-words">
                      {section.heading}
                    </h3>
                    <div className="space-y-3 sm:space-y-4">
                      {section.content.map((text, i) => (
                        <p key={i} className="break-words leading-relaxed">{text}</p>
                      ))}
                      {section.listItems && (
                        <ul className="list-disc pl-4 sm:pl-6 space-y-2 mt-3 sm:mt-4">
                          {section.listItems.map((item, i) => (
                            <li key={i} className="break-words leading-relaxed">
                              {item.label ? (
                                <>
                                  <strong className="font-bold">{item.label}:</strong> {item.text}
                                </>
                              ) : (
                                item.text
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                      {section.additionalContent && (
                        <p className="mt-3 sm:mt-4 break-words leading-relaxed">{section.additionalContent}</p>
                      )}
                    </div>
                  </div>
                ))}

                <div className="pt-3 sm:pt-4 border-t border-white/10">
                  <p className="text-xs sm:text-sm md:text-text-sm-custom text-brand-gray/80 break-words">
                    <strong className="font-bold">Last Updated:</strong> {terms.lastUpdated}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
